import Select from 'react-select';
import './ShopPage.css';
import { useDispatch, useSelector } from 'react-redux';
import { addCartItem, selectActiveCategoryFilter, selectActiveCollectionFilter, selectCategories, selectCollections, selectProducts, selectSort, setActiveCategoryFilter, setActiveCollectionFilter, setCategories, setCollections, setProducts, setSort } from './shopPageSlice';
import { useGetPricesMutation, useGetProductsMutation } from '../../services/api';
import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import { useEffect } from 'react';
import ProductList from '../../components/productList/ProductList';

const sortOptions = [
    { value: "featured", label: "Sort: Featured"},
    { value: "newest", label: "Sort: Newest"},
    { value: "lowToHigh", label: "Sort: Price Low to High"},
    { value: "highToLow", label: "Sort: Price High to Low"},
]

export default function ShopPage() {
    const dispatch = useDispatch();

    const sort = useSelector(selectSort);
    const products = useSelector(selectProducts);
    const categories = useSelector(selectCategories);
    const activeCategoryFilter = useSelector(selectActiveCategoryFilter);
    const collections = useSelector(selectCollections);
    const activeCollectionFilter = useSelector(selectActiveCollectionFilter);

    const [ getProducts, { isLoading: loadingProducts } ] = useGetProductsMutation();
    const [ getPrices ] = useGetPricesMutation();

    useEffect(() => {
        
        if (!products.length && !loadingProducts) {
            async function fetchData() {
                const productResponse = await getProducts().unwrap();
                const priceResponse = await getPrices().unwrap();
                
                let newCategories = ["All"];
                let newCollections = ["All"];
                const productList = productResponse.data.map(product => {
                    if (!newCategories.includes(product.metadata.Category) && product.metadata.Category) {
                        newCategories.push(product.metadata.Category);
                    }
                    if (!newCollections.includes(product.metadata.Collection) && product.metadata.Collection) {
                        newCollections.push(product.metadata.Collection);
                    }
                    const newObj = {
                        id: product.id,
                        productName: product.name,
                        category: product.metadata.Category,
                        subcategory: product.metadata.Subcategory,
                        collection: product.metadata.Collection,
                        productSKU: product.metadata['SKU'],
                        imgSrc: product.images[0],
                        created: product.created
                    }
                    const price = priceResponse.data.find(price => product.id === price.product);
                    newObj.price = price.unit_amount;
                    newObj.priceId = price.id;
                    return newObj;
                })

                dispatch(setProducts(productList));
                dispatch(setCategories(newCategories));
                dispatch(setCollections(newCollections));
            }

            fetchData();
        }
    })

    const handleSortChange = option => {
        dispatch(setSort(option))
    }

    const handleCategoryClick = event => {
        dispatch(setActiveCategoryFilter(event.target.id));
    }

    const handleCollectionClick = event => {
        dispatch(setActiveCollectionFilter(event.target.id));
    }

    const handleAddToCartClick = (productId, quantity) => {
        const productToAdd = products.find(product => product.id === productId);
        const newCartItem = {
            ...productToAdd,
            quantity: quantity
        };
        dispatch(addCartItem(newCartItem));
    }

    return (
        <section className="shopPage">
            <p className="tag">The Quaking Aspen Marketplace</p>
            <div className='row1'>
                <h2>Shop Fantasy</h2>
                <h3>Creations</h3>
            </div>
            <div className='row2'>
                <p>Discover epic dice vaults, towers, and immersive dungeon terrain designed for tabletop adventures and fantasy prop weapons for real adventures.</p>
                {/* <div>
                    <button>Shop Best Sellers</button>
                    <button>View New Releases</button>
                </div> */}
            </div>
            <div className='row3'>
                <div className='quickfilters'>
                    <div className='category'>
                        <h4>Categories</h4>
                        <ul className='categorySelector'>
                            {categories.map(category => <li id={category} className={activeCategoryFilter === category ? 'active' : ''} onClick={handleCategoryClick}>{category}</li>)}
                        </ul>
                    </div>
                    <div className='collection'>
                        <h4>Collections</h4>
                        <ul className='collectionSelector'>
                            {collections.map(collection => <li id={collection} className={activeCollectionFilter === collection ? 'active' : ''} onClick={handleCollectionClick}>{collection}</li>)}
                        </ul>
                    </div>
                </div>
                <div className='searchAndSort'>
                    <input placeholder='Search fantasy gear...'></input>
                    <Select 
                        className="react-select-container"
                        classNamePrefix={'react-select'}
                        options={sortOptions}
                        value={sort}
                        onChange={handleSortChange}
                    />
                </div>
            </div>
            {loadingProducts ? <LoadingSpinner /> : ''}
            {products ? <ProductList products={products} addToCartClick={handleAddToCartClick}/> : ''}
            
        </section>
    )
}